import $, { each } from 'jquery';
import './choices.js';
import forEach from 'lodash/forEach'
import find from 'lodash/find'
import clone from 'lodash/clone'
import map from 'lodash/map'
import every from 'lodash/every'
import orderBy from 'lodash/orderBy'
import remove from 'lodash/remove'
import times from 'lodash/times'
import Mark from 'mark.js'
import store from 'store2';
import uniq from 'lodash/uniq';

window.$ = $;


const options = {
    searchEnabled: true,
    shouldSort: false,
    itemSelectText: ''
};

$(() => {
    let enableDebug = false;
    let sortyBy = 'asc';
    let $body = $('body');
    let $api = $('.js-api');
    let $pagination = $('.js-pagination');
    let $productsResults = $('.js-products-results');
    let $productsFilters = $('.js-products-filters');
    let products = [];
    let filteredProducts = clone(window.products);
    let currentPage = 0;
    let pageLimit = 12;
    let activeFilters = [];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const collection = urlParams.get('collection') || '';
    let Filters = urlParams.get('filters') || '';
    let position = store.namespace('position');
    let Range = urlParams.get('range') || '';
    //?range=Circular%20Cove%20%26%20Frame


    if ($api.length) {

        if (position('page')) {
            currentPage = position('page');
        };



        if (position('filters') && position('filters').length) {
            Filters = position('filters');
        };


        let scroll = position('scroll');

        if (scroll) {
            setTimeout(() => {
                window.scrollTo({
                    top: scroll,
                    behavior: 'smooth',
                });

            }, 1000);
        }



        let productTemplate = (product) => {
            let debug = ``;
            forEach(product.SearchFilters, (filter) => debug += `${filter.Title} : ${filter.Value}<br>`);
            return `
            <div class="products__wrap__grid__results__item">
                <a href="${product.Link}" class="products__wrap__grid__results__item__image [ js-store-position ]">
                    <img src="${product.Image}" alt="${product.Title}">
                    <p class="products__wrap__grid__results__item__image__debug">
                        ${(enableDebug) ? debug : ``}
                    </p>
                </a>
                <a href="${product.Link}" class="products__wrap__grid__results__item__title [ js-store-position ]">
                    <p>${product.Title}</p>
                </a>
            </div>`};


        let filterTemplate = (filter) => {
            return `
            <div class="products__wrap__filters__accordion" data-filter="${filter.Title}">
                <div class="products__wrap__filters__accordion__title [ js-filter-accordion ] " data-title="${filter.Title}">${filter.Title}</div>
                <div class="products__wrap__filters__accordion__options [ js-filter-accordion-content ] " style="display:none;">
                    <div class="products__wrap__filters__accordion__options__item" style="display:none;">
                        <input id="all_${filter.Title}" class="checkbox" name="category" type="checkbox" value="All">
                        <label for="all_${filter.Title}">All</label>
                    </div>
                    ${filter.options.map(option => (option.Title) ? `
                    <div class="products__wrap__filters__accordion__options__item"> 
                        <input id="${filter.Title}_${option.Title.replace(/ /g, '_')}" data-id-for-url="${filter.Title}_${option.Title.replace(/ /g, '_')}" class="checkbox" name="category_${filter.Title}" type="checkbox" ${(collection.toLowerCase() === option.Slug.toLowerCase()) ? `checked="checked"` : ``} data-category="${filter.Title}" data-key="${option.Title}" value="${option.Title}">
                        <label for="${filter.Title}_${option.Title.replace(/ /g, '_')}">${option.Title}</label>
                    </div>
                    `: ``).join('')}
                </div>
            </div>`
        };


        const sortFilters = (filters) => {
            let sortedFilters = [];
            filters.forEach(filter => {
                filter.options = orderBy(filter.options, option => option.Title);
                sortedFilters.push(filter);
            });

            return sortedFilters;
        };


        const orderCategoriesOverride = (categories) => {

            const order = [
                'Circular Cover &amp; Frame',
                'Square Cover &amp; Frame',
                'Rectangular Cover &amp; Frame',
                'Concrete',
                'GATIC Multipart Cover System',
                'Circular Grate',
                'Sump Grate',
                'Gully Grate',
                'Gully Grate Vee Type',
                'Trench Grate',
                'GATIC Long Trench Run System',
                'Side Entry Cover',
                'Telecommunication',
                'Accessories',
                'Cover Accessories'
            ];

            let orderedCategories = orderBy(categories, [category => order.indexOf(category)], ['asc']);;
            return orderedCategories;
        }


        const orderFiltersOverride = (filters) => {
            const order = [
                'Series',
                'Type',
                'Load Class',
                'Clear Opening - W x L',
                'Markings',
                'Size',
                'Number of Parts',
                'End Connection',
                'Colour',
                'Rating',
            ];

            let orderedfilters = orderBy(filters, [product => order.indexOf(product.Title)], ['asc']);;
            return orderedfilters;
        }

        const renderFilters = (products) => {
            let dynamicFilters = [];
            forEach(products, product => {
                forEach(product.SearchFilters, filter => {
                    if (filter.Value) {
                        let filterCategory = find(dynamicFilters, { Title: filter.Title });
                        if (filterCategory) {
                            let filterOption = find(filterCategory.options, { Title: filter.Value });
                            if (!filterOption) {
                                filterCategory.options.push({
                                    Title: filter.Value,
                                    Key: filter.Key,
                                    Slug: filter.Value.replace(/ /g, '-').toLowerCase()
                                })
                            }
                        } else {
                            if (filter.Value) {
                                dynamicFilters.push({
                                    Title: filter.Title,
                                    Slug: filter.Title.replace(/ /g, '-').toLowerCase(),
                                    options: [{
                                        Title: filter.Value,
                                        Key: filter.Key,
                                        Slug: filter.Value.replace(/ /g, '-').toLowerCase()
                                    }]
                                })
                            }
                        }
                    }
                });
            });

            $productsFilters.empty();
            dynamicFilters = sortFilters(dynamicFilters);
            dynamicFilters = orderFiltersOverride(dynamicFilters);

            forEach(dynamicFilters, (filterCategory) => {
                $productsFilters.append(filterTemplate(filterCategory));
            });

            updateActiveFilters();

        }

        const filterByURL = () => {
            each(Filters.split(','), (index, option) => {
                let $option = $(`[data-id-for-url="${option}"]`);
                $option.prop('checked', true);
                $option.closest('.js-filter-accordion').prevUntil('.js-filter-accordion').addClass('active')
                $option.closest('.js-filter-accordion-content').addClass('active').slideDown();
            })
            updateActiveFilters()
        }

        const filterProducts = () => {

            let query = $('.js-query').val();
            filteredProducts = clone(window.products);
            if ($('.js-filter-level-1').val() !== '-1') {
                $(`.products__wrap__filters__accordion[data-filter='Clear Opening - W x L'] `).show();
                filteredProducts = remove(filteredProducts, product => {
                    return product.Category == $('.js-filter-level-1').val();
                });
            } else {
                $(`.products__wrap__filters__accordion[data-filter='Clear Opening - W x L'] `).hide();
            }

            each(activeFilters, (index, filter) => {
                remove(filteredProducts, product => {
                    return !find(product.SearchFilters, (filterItem) => {
                        return map(filter.Filters, 'Value').includes(filterItem.Value) && filterItem.Title.replace(/\s+/g, '-').toLowerCase() === filter.Category.replace(/\s+/g, '-').toLowerCase()
                    })
                });
            });


            if (query) {
                remove(filteredProducts, product => {
                    return every([
                        !product.Title.toLowerCase().includes(query.toLowerCase()),
                        !product.Code.toLowerCase().includes(query.toLowerCase()),
                        !product.Title.toLowerCase().includes(query.slice(0, -1).toLowerCase()),
                        !product.Code.toLowerCase().includes(query.slice(0, -1).toLowerCase())
                    ])
                });
            }


            return filteredProducts;
        }

        $('.js-query').on('keyup', function () { currentPage = 0; renderProducts() });

        const renderPagination = (filteredProducts) => {
            $pagination.empty();
            let pages = Math.ceil(filteredProducts.length / pageLimit);
            if (filteredProducts.length > pageLimit) {
                $('.products__wrap__grid__pagination').show();
                if (pages < 5) {
                    times(Math.ceil(pages), index => {
                        let page = (currentPage > 2) ? currentPage - 2 + index : index;
                        let current = (page === currentPage) ? 'current' : '';
                        $pagination.append(`<a href="#" class="products__wrap__grid__pagination__item products__wrap__grid__pagination__item--link products__wrap__grid__pagination__item--${current} [ js-paginate-to ]" data-page="${page + 1}">${page + 1}</a>`)
                    });
                } else {
                    times(5, index => {
                        let page = (currentPage > 2) ? currentPage - 2 + index : index;
                        let current = (page === currentPage) ? 'current' : '';
                        $pagination.append(`<a href="#" class="products__wrap__grid__pagination__item products__wrap__grid__pagination__item--link products__wrap__grid__pagination__item--${current} [ js-paginate-to ]" data-page="${page + 1}">${page + 1}</a>`)
                    });
                }
            } else {
                $('.products__wrap__grid__pagination').hide();
            }

            $('.js-paginate-to').each(function () {
                if (parseInt($(this).attr('data-page')) > pages) {
                    $(this).hide();
                }
            })

            if (filteredProducts.length / pageLimit + 1 < 2) {
                $('.products__wrap__grid__pagination').hide();
            }
        };

        const disableEnableFilters = (products) => {
            if ($('input.checkbox:checked').length) {
                $('input.checkbox:not(:checked)').attr('disabled', true);
            } else {
                $('input.checkbox').removeAttr('disabled')
            }

            forEach(products, product => {
                forEach(product.SearchFilters, filter => {
                    $(`input.checkbox[data-key="${filter.Value}"]`).removeAttr('disabled');
                })
            })

            $('.products__wrap__filters__accordion__options').each(function () {
                if ($(this).find('input.checkbox:checked').length) {
                    $(this).find('input').removeAttr('disabled')
                }
            });
        }

        const renderProducts = (products) => {
            $body.addClass('busy');
            setTimeout(() => {
                let query = $('.js-query').val();
                filteredProducts = filterProducts(filteredProducts);

                filteredProducts = orderBy(filteredProducts, ['Title'], [sortyBy]);
                renderPagination(filteredProducts);

                $productsResults.empty();

                if (filteredProducts.length) {
                    times(pageLimit, index => {
                        let itemIndex = index + currentPage * pageLimit;
                        if (filteredProducts[itemIndex]) {
                            $productsResults.append(productTemplate(filteredProducts[itemIndex]));
                        }
                    });
                }

                disableEnableFilters(filteredProducts);

                if (query && query.length > 0) {
                    let context = document.querySelectorAll('.products__wrap__grid__results__item');
                    let instance = new Mark(context);
                    instance.mark(query);
                }

                $body.removeClass('busy');
                $('.js-selected-products').text($('.js-filter-level-1').find(':selected').text().replace('&amp;', '&'));

                $('.products__wrap__grid__controls__count h6').text(`${filteredProducts.length} ${(filteredProducts.length > 1) ? `products` : `product`}`);

                if (window.wishlist && window.wishlist.data.products && window.wishlist.data.products.length) {
                    forEach(window.wishlist.data.products, id => {
                        $(`.js-wishlist-grid[data-id="${id}"]`).addClass('active');
                    })
                }
            }, 500);

        }

        const startUpFiltering = () => {



            if ($('.js-filter-level-1').val()) {
                let filteredProducts = clone(window.products);
                if ($('.js-filter-level-1').val() !== '-1') {
                    $(`.products__wrap__filters__accordion[data-filter='Clear Opening - W x L'] `).show();

                    filteredProducts = remove(filteredProducts, product => {
                        return product.Category == $('.js-filter-level-1').val();
                    });
                } else {
                    $(`.products__wrap__filters__accordion[data-filter='Clear Opening - W x L'] `).hide();
                }

                renderFilters(filteredProducts);
                renderProducts(filteredProducts);
                if (Filters) filterByURL();
            } else {
                products = window.products;
                renderFilters(filteredProducts);
                renderProducts(filteredProducts);
                if (Filters) filterByURL();
            }
        };


        setTimeout(() => {

            let categories = window.products.map(product => {
                return product.Category
            });

            categories = uniq(categories);

            categories = orderCategoriesOverride(categories);

            each(categories, (index, filter) => {
                $('.js-filter-level-1').append(`<option value="${filter}" ${(Range === filter) ? `selected="selected"` : ``}>${filter}</option>`)
            })

            $('.js-filter-level-1').append(`<option value="-1" selected>All products</option>`);

            if (Range) {
                console.log(`Preselected range: ${Range}`);
                $('.js-filter-level-1').val(Range);
            }

            if (position('dropdown')) {
                $('.js-filter-level-1').val(position('dropdown'))
            };



            store(false);


            $('.js-filter-level-1').each((index, element) => {
                new Choices(element, options);
            });



            $body.on('change', '.js-filter-level-1', (e) => {
                startUpFiltering();
            });

            startUpFiltering();

        }, 100)



        $body.on('click', '.js-filter-accordion', (e) => {
            e.preventDefault();
            let $this = $(e.currentTarget);
            $this.parent().toggleClass('active')
            $this.parent().find('.js-filter-accordion-content').toggleClass('active').slideToggle();
        });


        $body.on('click', '.js-toggle-filters', (e) => {
            e.preventDefault();
            $body.toggleClass('filters-active');
            if (!$body.hasClass('filters-active')) {
                $('.js-toggle-filters-text').text('Show filters');
            } else {
                $('.js-toggle-filters-text').text('Hide filters');
            }

        });


        const resetAllFilters = () => {
            $(`input.checkbox`).prop('checked', false);
        }

        $('.js-filter-level-1').on('change', (e) => {
            e.preventDefault();
            resetAllFilters();
        });

        const updateActiveFilters = () => {
            activeFilters = [];
            $('input.checkbox:checked').each(function () {
                if ($(this).val() === 'All') return;
                let filterCategory = find(activeFilters, { Category: $(this).attr('data-category') });
                if (filterCategory) {
                    let filterFilter = find(filterCategory.Filters, { value: $(this).val() });
                    if (!filterFilter) {
                        filterCategory.Filters.push({
                            Type: 'checkbox',
                            Value: $(this).val()
                        })
                    }
                } else {
                    activeFilters.push({
                        Category: $(this).attr('data-category'),
                        Filters: [{
                            Type: 'checkbox',
                            Value: $(this).val()
                        }]
                    })
                }
            });
            drawActiveFilters();
        }

        const drawActiveFilters = () => {
            $('.js-my-filters').empty();
            activeFilters.forEach((filter) => {
                filter.Filters.forEach(item => {
                    let html = `<div class="tag [ js-remove-tag ]" data-type="checkbox" data-value="${item.Value}">${item.Value}<span><svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 0a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM5.04 4.373l2.46 2.46 2.46-2.46.668.667L8.167 7.5l2.46 2.461-.666.667L7.5 8.168l-2.46 2.46-.668-.667 2.461-2.46-2.46-2.461.666-.667zM4 4l6.435 6.435m-6.188.247l6.435-6.435" fill="#555" fill-rule="evenodd"/></svg></span></div>`;
                    $('.js-my-filters').append(html);
                });
            });
            renderProducts();
        }

        updateActiveFilters();

        $body.on('click', 'input.checkbox', (e) => {
            currentPage = 0;
            let $this = $(e.currentTarget);
            if ($this.val() === 'All') {
                if ($this.prop('checked')) {
                    $this.closest('.js-filter-accordion-content').find('input.checkbox').prop('checked', true);
                } else {
                    $this.closest('.js-filter-accordion-content').find('input.checkbox').prop('checked', false);
                }
            }

            updateActiveFilters();

        });


        $body.on('click', '.js-remove-tag', (e) => {
            e.preventDefault();
            let $this = $(e.currentTarget);
            let type = $this.attr('data-type');
            let value = $this.attr('data-value');
            let from = $this.attr('data-from');
            let to = $this.attr('data-to');

            if (type === 'checkbox') {
                $(`input.checkbox[value="${value}"]`).prop('checked', false);
            }

            updateActiveFilters();
        });


        $body.on('click', '.js-paginate-to', (e) => {
            e.preventDefault();
            let $this = $(e.currentTarget);
            currentPage = parseInt($this.attr('data-page')) - 1;
            renderProducts();
        });

        $body.on('click', '.js-paginate-previous', (e) => {
            e.preventDefault();
            if (currentPage > 0) {
                currentPage = currentPage - 1;
                renderProducts();
            }
        });

        $body.on('click', '.js-paginate-next', (e) => {
            e.preventDefault();
            let filteredProducts = filterProducts(products)
            if (currentPage + 1 < filteredProducts.length / pageLimit) {
                currentPage = currentPage + 1;
                renderProducts();
            }
        });

        const capitalizeFirstLetter = (string) => {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        $body.on('click', '.js-store-position', (e) => {
            e.preventDefault();

            position('scroll', window.scrollY);

            position('page', currentPage);
            let tidyFilters = [];
            forEach(activeFilters, filter => {
                forEach(filter.Filters, subfilters => {
                    tidyFilters.push(`${capitalizeFirstLetter(filter.Category)}_${subfilters.Value.replace(/ /g, '_')}`)
                });
            });
            tidyFilters = tidyFilters.join()
            position('filters', tidyFilters);
            position('dropdown', $('.js-filter-level-1').val());


            window.location.href = $(e.currentTarget).attr('href');
        });

        $body.on('click', '.js-sort-products-by', (e) => {
            e.preventDefault();
            sortyBy = (sortyBy === 'asc') ? 'desc' : 'asc';
            renderProducts();
        });

    }


});